import { type Enum } from '@webapp/infrastructure/types/Enum'

export const ExpenseFormReimbursementCustomizations = {
  NO_DEFAULT: 'no_default',
  DEFAULT_YES: 'default_reimburse',
  DEFAULT_NO: 'default_no_reimburse',
  ALWAYS_YES: 'always_reimburse',
  ALWAYS_NO: 'always_no_reimburse',
} as const

export type ExpenseFormReimbursementCustomization = Enum<
  typeof ExpenseFormReimbursementCustomizations
>
